/* eslint-disable @typescript-eslint/ban-types */
import React, { useMemo, useState } from 'react';
import RCSlider from 'rc-slider'
import 'rc-slider/assets/index.css';
import { AnswerProps } from '../../molecules/Question';
import SliderStyled from './Slider.styles';

interface SliderProps {
  answers?: AnswerProps[];
  setSlideValue?: Function;
  baseColor?: string;
  handleColor?: string;
}

export const Slider = ({ answers, setSlideValue, baseColor = '#fff', handleColor = '#fff'}: SliderProps) => {

  const [answer, setAnswer] = useState(answers[2].text);

  const handleChange = (value) => {
    setAnswer(answers[value - 1].text);
    if (setSlideValue) setSlideValue(value);
  }

  const marks = useMemo(() => {
    const allMarks = {};

    answers.map((answer, i) => {
      allMarks[i + 1] = answer.text;
    });

    return allMarks;

  }, [answers]);


  return (
    <SliderStyled color={baseColor} className="slider" answerCount={answers.length}>
      <RCSlider
        min={1}
        max={answers.length}
        marks={marks}
        trackStyle={{}}
        defaultValue={3}
        handleRender={(handle) => {
            const attrs = handle?.props;
            return <div className="slider__handle" {...attrs}>
              <svg xmlns="http://www.w3.org/2000/svg" width="42.202" height="123.55" viewBox="0 0 42.202 123.55">
                <path d="M1494.668,1276.433a14.278,14.278,0,0,0-5.113-8.806c-.359-.264-.714-.52-1.093-.759-.419-.24-.781-.449-1.11-.6a14.6,14.6,0,0,0-1.994-.777,16.543,16.543,0,0,0-3.622-.649,23.487,23.487,0,0,0-3.24,0c-.994.07-1.859.159-2.792.268a61.258,61.258,0,0,0-10.865,2.328,3.881,3.881,0,0,0-.876.89c-2.623,4.148-2.308,7.149-1.236,9.182a9.035,9.035,0,0,0,4.219,3.748c-.553.323-1.114.627-1.663.962a4.129,4.129,0,0,0-.672,1.078c-1.758,4.658-1,7.529.4,9.269a7.032,7.032,0,0,0,2.769,2.012l-2.94,3.965-.911,1.229c-1.226-13.561-3.524-20.02-6.381,3.694-2.185,15.411-3.9,37.432-3.9,37.432l-.316,14.564-.236,11.022-.119,5.511-.089,4.64.141,2.634.035.658c.047.2.25.319.368.483l.824.919a24.137,24.137,0,0,0,1.682,1.793l1.786,1.649a6.115,6.115,0,0,0,.948.765l1.1.647a9.6,9.6,0,0,0,1.66.831q.825.327,1.658.621c.553.149,1.106.261,1.662.38l.833.162.819.068c.545.036,1.1.085,1.637.089a21.727,21.727,0,0,0,11.771-3.846l1.3-.907c.421-.334.83-.687,1.243-1.034a27.269,27.269,0,0,0,2.365-2.3,30.536,30.536,0,0,0,2.127-2.7l.969-1.491c.325-.5.542-.969.815-1.458a45.864,45.864,0,0,0,4.326-12.245c1.711-8.316,1.717-16.257,1.778-23.618l.138-22.048.138-22.05.07-11.025A36.385,36.385,0,0,0,1494.668,1276.433Zm-17.826,73.23h0C1476.844,1349.743,1476.845,1349.78,1476.842,1349.663Zm-8.579,13.351c-.87,1.872-1.624,3.706-2.253,5.43-.316.861-.6,1.7-.85,2.494l0,.017.4-19.022c.133.052.274.1.424.155a8.626,8.626,0,0,0,2.253.434,10.635,10.635,0,0,0,3.151-.317,11.851,11.851,0,0,0,2.208-.785c.447-.209.908-.469,1.376-.739a15.181,15.181,0,0,1-1.157,2.264l-1.652,2.672c-.54.9-1.038,1.742-1.476,2.528C1468.929,1361.283,1468,1363.342,1468.263,1363.014Zm6.829-14.967.007-.006,0,0Zm1.9-33.073c.079.029.074.027,0,0Zm-.662,21.449-.554.026-.137.009-.069.006-.005,0-.013-.009a.365.365,0,0,1-.172-.258.65.65,0,0,1,.073-.307c-.019,0-.037-.021-.027-.044l.016-.035.988-1.282h0c.842-1.087,1.739-2.227,2.7-3.6a34.556,34.556,0,0,0,2.706-4.625c.283-.592.553-1.212.813-1.848l-.079,13.076c0,.6-.007,1.191-.011,1.786a8.633,8.633,0,0,0-2.268-1.885,7.743,7.743,0,0,0-2.734-.933A9.57,9.57,0,0,0,1476.33,1336.424Zm.89-32.665h.013c.058.008.015,0,.028,0h-.007l-.008,0c-.01.006-.017.015-.025.012S1477.218,1303.766,1477.22,1303.758Zm5.531,3.662c-1.205-1.611-2.411-3.223-2.088-2.785l-.019-.009-.076-.036-.153-.071-.309-.134a8.021,8.021,0,0,0-2.542-.613c-.1-.006-.261-.014-.345-.018a.15.15,0,0,1,.025-.035l5.574-7.524Zm-15.685,16.188a7.2,7.2,0,0,0,1.327-.048c-.289.377-.585.761-.894,1.157h0l-1.349,1.764c-.3.4-.587.8-.875,1.207-.046-1.459-.094-2.945-.143-4.433.189.057.376.11.557.156A7.6,7.6,0,0,0,1467.067,1323.608Zm11.843,42.145c-.255.625-.605,1.152-.894,1.739-.325.45-.553.922-.915,1.343a10.552,10.552,0,0,1-1.09,1.245,12.056,12.056,0,0,1-1.236,1.125,12.294,12.294,0,0,1-5.284,2.482c1.121-1.591,2.444-3.494,4.077-5.7,1.075-1.384,2.225-2.805,3.422-4.218q.9-1.06,1.828-2.1c.61-.687,1.261-1.38,1.976-2.236.1-.116.194-.239.292-.359q-.324,1.459-.71,2.848A28.576,28.576,0,0,1,1478.909,1365.753Z" transform="translate(-1452.887 -1264.783)" fill={handleColor}/>
              </svg>
            </div>
        }}
        onChange={(value: number) => handleChange(value)}
      />
      <h2 className='slider__value'>{answer}</h2>
    </SliderStyled>
  )

}

export default Slider;